import { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";
import { useSelector } from "react-redux";
import { getUserId, selectSite, selectSiteLoginColor } from "../../../AsianExchangeSrc/utils/helper/commonSelectors";
import PaymentGateway from "./PaymentGateway";
import { getPaymentsByUserId } from "../../../AsianExchangeSrc/api/index";
import { format } from "date-fns";
import Loader from "../../../AsianExchangeSrc/utils/Loader";
import { useGradientColor, usePrimaryColor, useSecondaryColor } from "../../hooks/useThemeColors";

export default function Deposit() {
  const [amount, setAmount] = useState("");
  const [open, setOpen] = useState(false);
  const topHeaderColor = useSelector(selectSite())?.headerColor;
  const [userPayment, setUserPayment] = useState([]);
  const [loading, setLoading] = useState(false);
  const userID = useSelector(getUserId());
  const loginBtnColor = useSelector(selectSiteLoginColor());
  const SecondrayCtaBg = useSecondaryColor()
  const PrimaryColor = usePrimaryColor()


  const handleAmountChange = (e) => {
    setAmount(e?.target.value);
  };

  const handleQuickAmount = (value) => {
    setAmount((prevAmount) => {
      const currentAmount = parseInt(prevAmount) || 0;
      return (currentAmount + value).toString();
    });
  };

  const fetchPayment = async () => {
    try {
      setLoading(true);
      const res = await getPaymentsByUserId(userID);
      if (Array.isArray(res.data)) {
        setUserPayment(res.data);
      } else {
        console.error("Unexpected response format:", res.data);
        setUserPayment([]);
      }
    } catch (error) {
      console.error("Error fetching payment", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPayment();
  }, []);

  const handleBack = () => {
    window.history.back();
  };

  return (
    <div className="container mx-auto">
      {loading && <Loader />}
      <div className="flex flex-wrap">
        {/* Left Section */}
        <div className="w-full md:w-2/3 p-2">
          {!open && (
            <>
       

              <div className="shadow-md rounded p-4 bg-light-bg dark:bg-dark-bg">
                <form id="amountForm" method="post">
                  <input
                    type="hidden"
                    name="_token"
                    defaultValue="q0NGrW4D7O4NshxddDB9bmook0H18gEbSbmNnMFx"
                  />
                  <div className="mb-4">
                    <label className="block text-[15.5px] font-bold text-black dark:text-white">
                      Amount
                    </label>
                    <div className="flex mt-1">
                      <input
                        type="number"
                        className="border rounded-l px-4 py-4 w-full outline-blue bg-light-bg dark:bg-dark-bg text-black dark:text-white"
                        name="amount"
                        id="amount"
                        
                        onChange={handleAmountChange}
                        placeholder="Enter amount"
                      />
                      
                    </div>
                    <button
                        type="button"
                        className="w-full rounded-lg bg-gradient-to-r py-3 text-lg font-bold text-white mt-5"
                        style={{
                          backgroundImage: SecondrayCtaBg,
                        }}
                        onClick={() => setOpen(true)}
                      >
                        SUBMIT
                      </button>
                  </div>
                </form>
              </div>
            </>
          )}

          <section>
            <PaymentGateway
              amount={amount}
              open={open}
              toggle={() => setOpen(false)}
              fetchTransactions={() => fetchPayment()}
            />
          </section>
        </div>

        {/* Enhanced Right Section - Transaction History */}
        <div className="w-full md:w-1/3 p-2">
          <div className="bg-light-bg dark:bg-dark-bg shadow-md rounded-lg mt-2">
            <div
              className="p-4 border-b rounded-sm"
              style={{
                backgroundImage: PrimaryColor,
              }}
            >
              <div className="flex justify-between items-center">
                <h2 className="sm:text-base text-sm font-bold text-white">
                  Transaction History
                </h2>
                <button
                  onClick={fetchPayment}
                  className="rounded-full transition-colors"
                  title="Refresh transactions"
                >
                  <RefreshCw size={20} className="text-gray text-white" />
                </button>
              </div>
            </div>
            <div className="max-h-[400px] overflow-y-auto">
              <table className="w-full text-sm">
                <thead className="sticky top-0">
                  <tr
                    className="text-white text-xs uppercase rounded-sm"
                    style={{
                      backgroundImage: PrimaryColor,
                    }}
                  >
                    <th className="p-1.5 text-xs text-left">No</th>
                    <th className="p-1.5 text-xs text-left">Trans. ID</th>
                    <th className="p-1.5 text-xs text-right">Amount</th>
                    <th className="p-1.5 text-xs text-center">Status</th>
                    <th className="p-1.5 text-xs text-center">Time</th>
                    <th className="p-1.5 text-xs text-center">Date</th>

                    <th className="p-1.5 text-xs text-center">Reason</th>
                  </tr>
                </thead>
                <tbody id="Trans-head">
                  {userPayment?.length > 0 ? (
                    userPayment
                      ?.slice()
                      .reverse()
                      .map((e, i) => (
                        <tr
                          key={i}
                          className="hover:bg-gray-50 transition-colors bg-light-bg dark:bg-dark-bg"
                        >
                          <td className="p-3 text-left font-mono border-r border-black">
                            {i + 1}
                          </td>
                          <td className="p-3 text-left font-mono border-r border-black">
                            {e?.UTR}
                          </td>
                          <td className="p-3 text-right font-bold text-[13px] border-r border-black">
                            {parseFloat(e?.amount).toLocaleString("en-IN")}
                          </td>
                          <td className="p-3 text-center border-r border-black">
                            <span
                              className={`inline-block px-2 py-1 rounded-full text-xs font-medium ${
                                e?.status === "accepted"
                                  ? "bg-green-700 text-white"
                                  : e?.status === "pending"
                                  ? "bg-yellow-100 text-black"
                                  : "bg-red-100 text-red-800"
                              }`}
                            >
                              {e?.status}
                            </span>
                          </td>
                          <td
                            style={{ textWrap: "nowrap" }}
                            className="p-3 text-center text-gray-600 border-r border-black"
                          >
                            {format(new Date(e?.createdAt), "hh:mm a")}
                          </td>
                          <td
                            style={{ textWrap: "nowrap" }}
                            className="p-3 text-center text-gray-600 border-r border-black"
                          >
                            <span>
                              {" "}
                              {format(new Date(e?.createdAt), "dd MMM")}
                            </span>

                            {format(new Date(e?.createdAt), "yyyy")}
                          </td>
                          <td className="p-3 text-center text-gray-500">
                            {e?.remarks || "NA"}
                          </td>
                        </tr>
                      ))
                  ) : (
                    <tr className="w-full">
                      <td colSpan={8} className="p-4 text-center text-gray-500">
                        No transactions found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
